import axios from "axios";

const instance = axios.create();

export default instance;
